import { useMemo } from 'react'
import { preFixImgUrl } from '@/utils'

export type VipTopGridItem = { img: string; titleKey: string }
export type VipFeatureScreen = { img: string; titleKey: string; subKey: string }
export type QuickLinkItem = { key: string; iconImg: string }

const VIP_TOP_GRID_IMAGES = [
  '8359b5b1bf41eb26542bd1b836a276b7.png',
  'bc8c1eb9dc6e70318703b81a6fce1b28.png',
  'e2b347132a8379a14e5f420be5847190.png',
  '5a8d24e24037aa2df2f563d604569773.png',
  'de84780b353e43831dab99c238ace439.png',
  '704e3ca0c23351ff3d983a84187c96f6.png',
] as const

const VIP_TOP_GRID_KEYS = [
  '2aeb4b9a',
  'f9a12794',
  '2b7c879b',
  '032751c0',
  '4f4428fe',
  '8b0d3c1d',
] as const

/** 服务特色手机示意（与设计顺序一致，可替换资源） */
const VIP_PHONE_FILES = [
  '6bd6072856b8c05968664a686af6f64f.png',
  'af4564d0ae55009da4645b538cb20ca8.png',
  '91de6407e20d065015c17f40927aa222.png',
  '75bd55deb4bcd0a36b625d244e09bc9f.png',
  'eac8ca781804e7a14f2db70f182c7ffd.png',
] as const

const VIP_PHONE_TITLE_KEYS = ['14ba7ae2', '768ebe74', '527c3183', '349a2de4', 'e4a4499e'] as const
const VIP_PHONE_SUB_KEYS = ['54ae613c', '7e3684e5', 'cb27cd41', '43109e58', 'e81bc272'] as const

const QUICK_LINK_KEYS = ['00a5d8ee', '487853f3', '30cef6b4', '2c7782ea'] as const
const QUICK_LINK_ICON_FILES = [
  'e62cca86d301cb431507da5775a49803.png',
  '604ce17e39d715e03b02aba7b3874804.png',
  '05e814b0f7beb684207c85db7417ec8d.png',
  '691e96c40a4369e0f941c4b9fdf709da.png',
] as const

export default function useModel() {
  const topGridItems = useMemo<VipTopGridItem[]>(
    () =>
      VIP_TOP_GRID_IMAGES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: VIP_TOP_GRID_KEYS[i],
      })),
    [],
  )

  const serviceFeatureScreens = useMemo<VipFeatureScreen[]>(
    () =>
      VIP_PHONE_FILES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: VIP_PHONE_TITLE_KEYS[i],
        subKey: VIP_PHONE_SUB_KEYS[i],
      })),
    [],
  )

  const quickLinks = useMemo<QuickLinkItem[]>(
    () =>
      QUICK_LINK_KEYS.map((key, i) => ({
        key,
        iconImg: preFixImgUrl(QUICK_LINK_ICON_FILES[i]),
      })),
    [],
  )

  return { topGridItems, serviceFeatureScreens, quickLinks }
}
